module.exports = __webpack_public_path__ + "img/LI.a2735908.png";